/**
 * Team member type DTO - represents the wire format used by the backend API.
 */
export enum TeamMemberTypeDTO {
  REGULAR_MEMBER = 'REGULAR_MEMBER',
  PLACEHOLDER = 'PLACEHOLDER',
}

/**
 * Type alias for team member type in API requests.
 */
export type TeamMemberTypeRequest = TeamMemberTypeDTO;

/**
 * Type alias for team member type in API responses.
 */
export type TeamMemberTypeResponse = TeamMemberTypeDTO;
